/**
 * This code was generated by Builder.io.
 */
import React from "react";
import styles from "./progressBar.module.css";

const ProgressBar = ({ currentStep, totalSteps }) => {
    return (
        <div className={"tw-w-full"}>
            <p className={styles.progressText}>
                You're at step {currentStep}/{totalSteps}. Let's begin!
            </p>
            <div className={"tw-flex tw-gap-1 tw-items-center tw-justify-center"}>
                {[...Array(totalSteps)].map((_, index) => (
                    <div
                        key={index}
                        className={`${index === 0 && "tw-rounded-l-full"} ${index === totalSteps - 1 && "tw-rounded-r-full"} ${" tw-h-[10px] tw-w-[68px]"} ${index < currentStep ? "tw-bg-primary" : "tw-bg-background_secondary_color"}`}
                    />
                ))}
            </div>
        </div>
    );
};

export default ProgressBar;
